import flowVid from "../../../../src/video/grid-cloud.mp4";
import flowVid2 from "../../../../src/video/grid-cloud2.mp4";
import * as React from 'react';
export default {
  flowVid,
  flowVid2,
  React
};